import ApplicationComponent from "legacy/ApplicationComponent"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { humanize, isListedPumpPrice } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class ChargeItemsList extends ApplicationComponent {
  tdClassName(id) {
    if (this.props.lastUpsertedItemId === id) {
      return "py-4 bg-teal-100 group-hover:bg-gray-100"
    } else if (this.props.selectedChargeItemId === id) {
      return "py-4 bg-blue-50"
    } else {
      return "py-4 group-hover:bg-gray-100"
    }
  }

  formatUnitPrice(price) {
    if (price == null) return null
    const modulo = price % 1
    const trimDecimals = modulo === 0 ? Math.floor(price) : price
    return `$${trimDecimals}`
  }

  renderRow(chargeItem) {
    const id = _.uniqueId()
    return (
      <tr key={id} className="group">
        <td className={this.tdClassName(id)}>{chargeItem.name}</td>
        <td className={[this.tdClassName(id), "w-1/5"].join(" ")}>
          {humanize(chargeItem.category)}
        </td>
        <td className={[this.tdClassName(id), "w-1/5"].join(" ")}>
          {chargeItem.frequency && humanize(chargeItem.frequency)}
        </td>
        <td className={this.tdClassName(id)}>
          {this.formatUnitPrice(chargeItem.unitPrice)}
        </td>
        <td className={this.tdClassName(id)}>
          {this.props.renderTaxRate(chargeItem)}
        </td>
        <td className={`${this.tdClassName(id)} shrink space-x-4 text-right`}>
          <button
            type="button"
            role="button"
            className="btn btn-sm btn-ghost group-hover:border-blue-800"
            onClick={() => this.props.showForm(true, chargeItem)}
          >
            Edit
          </button>
          {
            <NextButton
              click={() => this.props.deleteChargeItem(chargeItem)}
              processing={this.props.processingDelete === id}
              processingText=" Deleting..."
              icon=""
              text="Delete"
              btnClass={`btn btn-sm btn-ghost group-hover:border-blue-800 ${
                isListedPumpPrice(chargeItem) ? "invisible" : ""
              }`}
            />
          }
        </td>
      </tr>
    )
  }

  render() {
    return (
      <div>
        <div className="table-responsive">
          <div className="grid grid-cols-2">
            <h2 className="text-base font-semibold">
              Listed Pump Prices
              <i
                className="fa-kit fa-info cursor-pointer px-2 py-1 text-xs text-gray-500"
                data-container="body"
                data-toggle="popover"
                data-placement="top"
                data-content="These items sync with Marinas.com and are visible to Boaters."
              />
            </h2>

            {this.props.listedPumpPriceLastUpdatedAt && (
              <p className="mt-5 text-right text-xs text-gray-700">
                Last updated on {this.props.listedPumpPriceLastUpdatedAt}
              </p>
            )}
          </div>
          <table className="table">
            <thead>
              <tr>
                <th className="border-t-0">Name</th>
                <th className="border-t-0">Category</th>
                <th className="border-t-0">
                  Frequency
                  {$context.packagingPosEnabled && (
                    <i
                      className="fa-kit fa-info cursor-pointer px-2 py-1 text-xs text-gray-500"
                      data-container="body"
                      data-toggle="popover"
                      data-placement="top"
                      data-content="Only items with a price and One Time frequency will appear in New Sale."
                    />
                  )}
                </th>
                <th className="border-t-0">Price</th>
                <th className="border-t-0">Tax</th>
                <th className="sr-only border-t-0">Actions</th>
              </tr>
            </thead>
            <tbody>
              {_.map(
                this.props.chargeItems.filter(isListedPumpPrice),
                (chargeItem) => this.renderRow(chargeItem)
              )}
            </tbody>

            <tbody className="border-t-0">
              <tr>
                <th className="border-t-0 p-0">
                  <h2 className="text-base font-semibold">Standard Charges</h2>
                </th>
              </tr>
            </tbody>

            <thead>
              <tr>
                <th className="border-t-0">Name</th>
                <th className="border-t-0">Category</th>
                <th className="border-t-0">
                  Frequency
                  {$context.packagingPosEnabled && (
                    <i
                      className="fa-kit fa-info cursor-pointer px-2 py-1 text-xs text-gray-500"
                      data-container="body"
                      data-toggle="popover"
                      data-placement="top"
                      data-content="Only items with a price and One Time frequency will appear in New Sale."
                    />
                  )}
                </th>
                <th className="border-t-0">Price</th>
                <th className="border-t-0">Tax</th>
                <th className="sr-only border-t-0">Actions</th>
              </tr>
            </thead>
            <tbody>
              {_.map(
                _.reject(this.props.chargeItems, isListedPumpPrice),
                (chargeItem) => this.renderRow(chargeItem)
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

ChargeItemsList.propTypes = {
  chargeItems: PropTypes.array.isRequired,
  listedPumpPriceLastUpdatedAt: PropTypes.string,
  selectedChargeItemId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  showForm: PropTypes.func.isRequired,
  lastUpsertedItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  deleteChargeItem: PropTypes.func.isRequired,
  processingDelete: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
  renderTaxRate: PropTypes.func.isRequired,
}

export default ChargeItemsList
